import {
  styled,
  alpha,
  Theme,
  Button as BaseButton,
  IconButton as BaseIconButton,
  Divider as BaseDivider,
} from '@mui/material'

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0.5),
  paddingLeft: theme.spacing(1.5),
  borderRadius: 999,
  border: `1px solid ${alpha(theme.palette.primary.contrastText, 0.3)}`,
  backgroundColor: alpha(theme.palette.primary.contrastText, 0.15),
  color: theme.palette.primary.contrastText,

  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(1.25),
  },
}))

export const Time = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.75),
  fontSize: 16,
  fontWeight: 700,
  // Keeps the width steady as the digits change
  fontVariantNumeric: 'tabular-nums',

  '& svg': {
    fontSize: 20,
  },
}))

const getExtendButtonStyles = (theme: Theme) => ({
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.common.white,

  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.9),
  },
})

export const Button = styled(BaseButton)(({ theme }) => ({
  ...getExtendButtonStyles(theme),
  height: 32,
  padding: theme.spacing(0, 1.5),
  borderRadius: 999,
  fontSize: 13,
  textTransform: 'none',
  fontWeight: 700,
  whiteSpace: 'nowrap',

  '& .MuiButton-startIcon > svg': {
    fontSize: 18,
  },
}))

export const IconButton = styled(BaseIconButton)(({ theme }) => ({
  ...getExtendButtonStyles(theme),
  width: 28,
  height: 28,

  '& svg': {
    fontSize: 18,
  },
}))

// Only icons are shown on mobile, so there is nothing to separate there
export const Divider = styled(BaseDivider)(({ theme }) => ({
  height: 32,
  borderColor: alpha(theme.palette.primary.contrastText, 0.3),

  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}))
